const scrollIntoViewWithOffset = (selector, offset) => {
  locoScroll.scrollTo(selector);
};

function scrollToNextSection() {
  let sections = document.querySelectorAll('.section');
  sections.forEach((section) => {
    let button = section.querySelector('.scrollToNextSection');
    if (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        scrollIntoViewWithOffset(section.nextElementSibling);
      });
    }
  });
  locoScroll.resize();
}

function setCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = '; expires=' + date.toGMTString();
  } else var expires = '';
  document.cookie = name + '=' + value + expires + '; path=/';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function deleteCookie(name) {
  setCookie(name, '', -1);
}

function homeVideoOverlay() {
  // Show Overlay Video HomePage
  if (
    document.getElementById('HomeVideoDialog') &&
    getCookie('dialogHomeVideoShow') != 'yes' &&
    meta.page.pageType === 'home' &&
    !Shopify.designMode
  ) {
    var dialogHomeVideoEl = document.getElementById('HomeVideoDialog');
    var dialogHomeVideo = new A11yDialog(dialogHomeVideoEl);

    dialogHomeVideo
      .on('show', (event) => {
        bodyScrollLock.disableBodyScroll(dialogHomeVideoEl);
      })
      .on('hide', () => {
        bodyScrollLock.enableBodyScroll(dialogHomeVideoEl);
        setCookie('dialogHomeVideoShow', 'yes', 365);
      });

    dialogHomeVideo.show();
  }
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToNextSection();

  // Popup Age visibile dopo 3 minuti
  // se il cookie "displayedPopupAge" ha valore diverso da "yes"
  if (getCookie('dialogAlertAgeShow') != 'yes' && document.getElementById('AlertAgeDialog') && !Shopify.designMode) {
    var dialogAlertAgeEl = document.getElementById('AlertAgeDialog');
    var dialogAlertAge = new A11yDialog(dialogAlertAgeEl);

    dialogAlertAge
      .on('show', (event) => {
        bodyScrollLock.disableBodyScroll(dialogAlertAgeEl);
      })
      .on('hide', () => {
        bodyScrollLock.enableBodyScroll(dialogAlertAgeEl);
        setCookie('dialogAlertAgeShow', 'yes', 365);
        // homeVideoOverlay();
      });

    dialogAlertAge.show();
  } else {
    // homeVideoOverlay();
  }
});
